/**
 * Formats a byte count as a human-readable size (B / KB / MB / GB).
 * Confirmed as a real, reproducible bug before this existed: a shared
 * file-list component was always formatting as MB with 2 decimals, so
 * any file under ~10KB displayed as "0.00 MB" -- not wrong math, just
 * the wrong unit for small files. One shared formatter here instead of
 * each tool inventing its own, so every caller gets the same (correct)
 * behavior.
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
